/**
 * DS-internal hook : le compte qu'une barre d'avancée montre quand elle doit se remplir sous les
 * yeux — celui d'avant le geste (`fromCount`), puis, un instant après, le compte. `onFilled` dit le
 * moment où la barre rejoint le compte (l'écran y joue son son). Moins d'animation demandé : le
 * compte arrive tout de suite (le livre veut « le résultat arrive »). Sans `fromCount` en deçà du
 * compte, la barre est au compte, immobile.
 *
 * C'est l'animation de l'ancienne quête de l'accusé d'un achat (`ProgressBarM` : 100 ms puis 500 ms).
 */
import { useEffect, useRef, useState } from "react"

import { useReduceMotion } from "./useReduceMotion"

/** L'attente avant que la barre rejoigne le compte. */
export const FILL_DELAY_MS = 600

export function useFilledCount(count: number, fromCount: number | null | undefined, onFilled?: () => void): number {
    const reduceMotion = useReduceMotion()
    const animates = fromCount != null && fromCount < count
    const [filled, setFilled] = useState(!animates)
    const onFilledRef = useRef(onFilled)
    onFilledRef.current = onFilled

    useEffect(() => {
        if (!animates) return
        setFilled(false)
        const timer = setTimeout(
            () => {
                setFilled(true)
                onFilledRef.current?.()
            },
            reduceMotion ? 0 : FILL_DELAY_MS
        )
        return () => clearTimeout(timer)
    }, [animates, fromCount, count, reduceMotion])

    return animates && !filled ? (fromCount as number) : count
}
